import React from "react";

const STATS = [
  { value: "50+", label: "Clients" },
  { value: "5M+", label: "Monthly Reach" },
  { value: "5x", label: "Average Engagement Lift" },
];

// Sits inside .bv-panel right after the closing tagline — the `bv-origin-item`
// class and the style prop (a transitionDelay) are what wire it into that
// panel's shared fade-up reveal, so it appears as the next beat of the same
// sequence rather than its own animation.
const OriginStatsStrip = ({ style }) => (
  <div className="bv-stats bv-origin-item" style={style}>
    {STATS.map((stat) => (
      <div className="bv-stat" key={stat.label}>
        <span className="bv-stat-value">{stat.value}</span>
        <span className="bv-stat-label">{stat.label}</span>
      </div>
    ))}
  </div>
);

export default OriginStatsStrip;
